import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

export default {
	_defaultParamInfo: {
		itemId: {
			name: "ID",
			inpType: "text"
		},
		dateUpd: {
			name: "更新日",
			inpType: "datetime"
		}
	},
	
	/**
	 * パラメータの名称をセットする関数
	 * @param {$Object} $elm
	 * @param {Object} [dataParams]
	 * @returns Boolean
	 */
	_replaceParamName($elm, dataParams) {
		u_.isObject(dataParams) || (dataParams = this.container.module.config.dataParams);
		
		const pk = $elm.attr("data-echo-pn");
		if(!pk) {
			$elm.remove();
			return false;
		}
		
		const pi = u_.isObject(dataParams[pk]) ? dataParams[pk] : {};
		if( !Object.keys(pi).length && u_.hasProperty(this._defaultParamInfo, pk) ) {
			Object.assign(pi, this._defaultParamInfo[pk]);
		}
		
		if( !u_.hasProperty(pi, "name") ) {
			if(pk.indexOf(".") > 0) {
				// [for inpType: array]
				const keys = pk.split(".");
				const paramInfo = dataParams[ keys.shift() ];
				if( u_.isObject(paramInfo) && u_.isObject(paramInfo.dataParams) ) {
					$elm.attr("data-echo-pn", keys.join("."));
					return this._replaceParamName($elm, paramInfo.dataParams);
				}
			}
			
			$elm.remove();
			return false;
		}
		
		const $replace = $("<span/>").addClass(`echoed-name ${$elm.get(0).className}`);
		!!pi.name && $replace.html( $.parseHTML(pi.name) );
		$elm.replaceWith($replace);
		return true;
	},
	
	/**
	 * パラメータの値をセットする関数
	 * @param {Object} item
	 * @param {$Object} $elm
	 * @param {Object} [dataParams]
	 * @returns
	 */
	_replaceParamData(item, $elm, dataParams) {
		u_.isObject(dataParams) || (dataParams = this.container.module.config.dataParams);
		
		const pk = $elm.attr("data-echo-pd");
		if(!pk) {
			$elm.remove();
			return false;
		}
		
		const pi = u_.isObject(dataParams[pk]) ? dataParams[pk] : {};
		if( !Object.keys(pi).length && u_.hasProperty(this._defaultParamInfo, pk) ) {
			Object.assign(pi, this._defaultParamInfo[pk]);
		}
		
		if(!pi.inpType) {
			if(pk.indexOf(".") > 0) {
				// [for inpType: array]
				const keys = pk.split(".");
				const paramInfo = dataParams[ keys[0] ];
				item = item[ keys.shift() ];
				if(
					Array.isArray(item) &&
					u_.isObject(paramInfo) &&
					u_.isObject(paramInfo.dataParams)
				) {
					$elm.attr( "data-echo-pd", keys.join(".") );
					item.forEach(data => this._replaceParamData(
						data,
						$elm.clone().insertBefore($elm),
						paramInfo.dataParams
					));
					$elm.remove();
					return true;
				}
			}
			
			$elm.remove();
			return false;
		}
		
		const className = `echoed-data type-${pi.inpType} ${$elm.get(0).className}`;
		const args = [pk, pi, className];
		const isEmpty = u_.isObject(item) ? "" : "Empty";
		!isEmpty && args.unshift(item);
		const createFn = `_create${isEmpty}ElementByParamInfo`;
		const $replace = this[createFn].apply(this, args);
		
		if($replace instanceof $) {
			$elm.replaceWith( $replace.attr("data-key", pk) );
			return true;
			
		} else {
			$elm.remove();
			return false;
		}
	}
};
